import {ParameterDefinitionType} from '@volkswagen-onehub/vw-starter-framework';
import {BffQueryParams} from './parameter';
import {commonParameterDefinition} from '../routes/common-parameter-definition';

export const defaultParameterDefinition: ParameterDefinitionType<BffQueryParams> =
  {
    ...commonParameterDefinition,
    showroomNodeId: {
      cacheKey: true,
      description:
        'the showroom node id identifies the model-structure to be displayed.',
    },
    models: {
      cacheKey: true,
      multiple: true,
      type: 'object',
      description:
        'the models to be displayed ({carline}/{salesgroup?}/{trim?}).',
    },
    dimensionImagesTrim: {
      cacheKey: true,
      description: 'the trim to be used for displaying images.',
    },
    defaultTrim: {
      cacheKey: true,
      description:
        'the default trim to be selected in the trim filter. Will also be used for displaying images.',
    },
    profileId: {
      cacheKey: true,
      description:
        'the profile id is configured in ACS. It can be used as a parameter in the action url or defined in the model-structure for a showroom. It bundles certain configuration options into a single identifier.',
    },
  };
